<template>
  <div class="container">

    <!-- TABS -->
    <div v-if="matters" class="panel-nav">
      <ul class="tab">
        <li v-for="(m, n) in matters" class="tab-item" :class="{active: tab === n}">
          <a href="" @click.prevent="tab = n">{{m.visatype.name}}</a>
        </li>
      </ul>
    </div>
    <!-- END TABS -->

    <matterdocs v-for="(m, n) in matters" v-show="tab === n" :key="m.matter._id" :matterdata="m"></matterdocs>

  </div>
</template>

<script>
import matterDocs from '@/components/documents/matterDocs'
export default {
  name: 'clientDocs',
  components: { matterdocs: matterDocs },
  data () {
    return {
      tab: 0
    }
  },
  created () {
    this.$root.$data.pageTitle = 'Documents'
  },
  computed: {
    matters () {
      let matters = this.$root.$data.client.matters
      if (!matters.length) return null
      return matters
    }
  }
}
</script>



// WEBPACK FOOTER //
// clientDocs.vue?1e10e168